import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';
import merge from 'lodash/merge';
import R from '../../../core-res/R';
import DRNButton from '../../Button/DRNButton';
import DRNText from '../../../standard/Text/DRNText';
// Variant
const POSITIVE = 'POSITIVE';
const ALERT = 'ALERT';
const WARNING = 'WARNING';
// TODO: Deprecate this type (will be replaced by variant props)
const SUCCESS = 'SUCCESS';
const ERROR = 'ERROR';
export default class Snackbar extends Component {
    componentDidMount() {
        if (this.props.type) {
            console.warn('Using "type" props at Snackbar V1 will be deprecated. Please use "variant" props instead');
        }
    }
    getStyleByVariant() {
        const { type, variant } = this.props;
        return stylesByVariant[type || variant];
    }
    render() {
        const { message, style = {}, actionOnPress, actionText, renderAction } = this.props;
        const styles = merge({}, _styles, this.getStyleByVariant());
        return (<View style={[styles.container, style]}>
        <DRNText style={styles.message}>{message}</DRNText>
        <DRNButton.IconStart onPress={actionOnPress} buttonStyle={Object.assign({}, R.style.buttonText, { textColors: {
                disabled: styles.actionText.color,
                pressed: styles.actionText.color,
                active: styles.actionText.color,
            } })} buttonTextStyle={{ small: styles.actionText }} text={actionText} size={'small'} Icon={renderAction}/>
      </View>);
    }
}
Snackbar.propTypes = {
    message: PropTypes.string.isRequired,
    actionText: PropTypes.string,
    actionOnPress: PropTypes.func,
    type: PropTypes.oneOf([SUCCESS, ERROR, WARNING]),
    variant: PropTypes.oneOf([POSITIVE, ALERT, WARNING]),
};
Snackbar.defaultProps = {
    message: '',
    variant: POSITIVE,
};
const _styles = {
    container: {
        width: '100%',
        padding: R.spacing.xs,
        flexDirection: 'row',
        alignItems: 'center',
    },
    message: {
        color: R.color.uiLightPrimary,
        fontSize: 14,
        lineHeight: 16,
        flex: 1,
        marginRight: R.spacing.xs,
    },
    actionText: {
        color: R.color.uiLightPrimary,
        fontSize: 14,
        lineHeight: 16,
        fontWeight: 'bold',
    },
    actionContainer: {
        alignItems: 'center',
        justifyContent: 'center',
    },
};
const stylesByVariant = {
    [POSITIVE]: {
        container: {
            backgroundColor: R.color.uiGreenSecondary,
        },
    },
    [ALERT]: {
        container: {
            backgroundColor: R.color.uiRedSecondary,
        },
    },
    [WARNING]: {
        container: {
            backgroundColor: R.color.uiYellowPrimary,
        },
        message: {
            color: R.color.textPrimary,
        },
        actionText: {
            color: R.color.textPrimary,
        },
    },
    // TODO: Deprecate this later
    [SUCCESS]: {
        container: {
            backgroundColor: R.color.uiGreenSecondary,
        },
    },
    [ERROR]: {
        container: {
            backgroundColor: R.color.uiRedSecondary,
        },
    },
};
